export const navMiniItems = [
    {
        title: "01",
        link: "home"
    },
    {
        title: "02",
        link: "about"
    },
    {
        title: "03",
        link: "skills"
    },
    {
        title: "04",
        link: "services"
    },
    {
        title: "05",
        link: "portfolio"
    },
    {
        title: "06",
        link: "contact"
    }
]

export const navMajorItems = [
    {
        title: "01 - HOME",
        link: "home"
    },
    
    {
        title: "02 - SKILLS",
        link: "skills"
    },
    {
        title: "03 - SEVICES",
        link: "services"
    },
    {
        title: "04 - PORTFOLIO",
        link: "portfolio"
    },
    {
        title: "05 - TESTIMONIALS",
        link: "testimonials"
    },

    {
        title: "06 - CONTACT",
        link: "contact"
    }
]

export const services = [
    {
        image:"/images/service3.png",
        alt:"website dev",
        body:"I am a specialist in the development of several types of website in any industry front end from start to finish. Check out my skills above!",
        subtitle:"Website Development"
    },
    {
        image:"/images/service1.png",
        alt:"theme building",
        body:"I am experienced in working with many CMS platforms like WordPress, Shopify, Wix, Webflow, and SquareSpace; develop awesome, responsive sites. ",
        subtitle:"CMS Development"
    },
    {
        image:"/images/service4.png",
        alt:"UI design",
        body:"With graphics design and web design skills, I design mockups and templates that are responsive and follow all best practices.",
        subtitle:"UI/UX Design"
    },
    {
        image:"/images/service2.png",
        alt:"website red",
        body:"I help in redesigning, upgrading, and updating existing websites. I simply take businesses to the next level with my skills.",
        subtitle:"Website Redesign"
    }
]

export const portfolio = [
    {
        id:1,
        name: "AEsKay Services",
        cover: "images/portfolio/aeskay.png",
        details: "Aeskay services is a react project that displays arrays of services rendered by Aeskay. It shows courses, contact details, and has functions such as the ability to like or dislike the course. Context API was used for the state management",
        link: "https://zealous-lewin-e92d09.netlify.app/"
    },
    {
        id:2,
        name: "Andrea Carter",
        cover: "images/portfolio/andrea.png",
        details: "Andrea Carter is a personal business website that belongs to Andrea Carter, PhD. A prolific and award winning writer.",
        link: "http://www.andrea-carter.com"
    },
    {
        id:3,
        name: "Blog With React",
        cover: "images/portfolio/blog.png",
        details: "Blog with React is a blog website created with ReactJS. It works on Redux Toolkit. It is very responsive and has many modern features",
        link: "https://blog-with-react.netlify.app/"
    },
    {
        id:4,
        name: "Blue Esteem",
        cover: "images/portfolio/bluest.png",
        details: "Bluestem Equity is an investment management group that looks to leverage the operational experience from Mustang Cat’s leadership team.",
        link: "http://www.bluestemequity.com"
    },
    {
        id:5,
        name: "Crown Concentrates",
        cover: "images/portfolio/crown.png",
        details: "Crown Concentrates is a luxury line of hemp products infused with hemp for those who wish to feel the effect of the plant and not the high. We offer several hemp-infused options to allow users to help with pain management, anxiety and antiviral properties from hemp-derived CBD that bears the Crown Concentrates",
        link: "http://www.crownconcentrateshemp.com/"
    },
    {
        id:6,
        name: "The Drive Academy",
        cover: "images/portfolio/drive.png",
        details: "One of the fastest rising sector in the world is the Technological Space. Relevant skills are now required and highly sorted after. At the Drive Academy, you will be equipped with the right skill set to gain a strong footing in the tech driven world.",
        link: "http://www.thedriveacademy.org"
    },
    {
        id:7,
        name: "Fika Agency",
        cover: "images/portfolio/fika.png",
        details: "Fika is an renowned digital agency offering services such as Website Development, SEO, Social Media Marketing and Virtual Assistant Services. We have an extremely experienced team and our sole focus is customer satisfaction.",
        link: "https://fika.agency/"
    },
    {
        id:8,
        name: "Fint NewYork",
        cover: "images/portfolio/fint.png",
        details: "FINTNEWYORK.COM is an online store that sells clothing and accessories for women and men made by designers. We act as a bazaar for clothing designers by making sure their creations are delivered to customers with ease while offering a great, sociable surrounding online and in-person experiences. We are dedicated to providing quality services and interactions to our customers in a loyal manner.",
        link: "https://www.fintnewyork.com/Default.asp"
    },
    {
        id:9,
        name: "GNK Studios",
        cover: "images/portfolio/gnk.png",
        details: "GNK is a branding firm in Nigeria. We deal with all kinds of design, branding, brand identity, website development, among others.",
        link: "https://gnkstudios.org/"
    },
    {
        id:10,
        name: "Ninki Online",
        cover: "images/portfolio/niki.png",
        details: "NINKI creates content that amplifies your brand story, increases your online presence and helps you build meaningful relationships with your customers. ",
        link: "https://ninkionline.com/"
    },
    {
        id:11,
        name: "Nude Herbs",
        cover: "images/portfolio/nude.png",
        details: "Over a wealth of published scientific studies, journals, patents and interviews, Nude Herbs has cultivated a diverse academic and professional career that focuses on enhancing the body’s natural processes. ",
        link: "http://www.nudeherbs.com.au"
    },
    {
        id:12,
        name: "Oceans View",
        cover: "images/portfolio/oceans.png",
        details: "2817 3rd Street is a new TIC development in the heart of Santa Monica’s Ocean Park neighborhood and just two blocks to Main Street and three blocks to The Pacific Ocean. We are offering four unique townhome-like units for sale in a lush garden setting. ",
        link: "http://www.oceanviewson3rd.com"
    },
    {
        id:13,
        name: "Quotes Generator",
        cover: "images/portfolio/quotes.png",
        details: "Quotes Generator generates random quotes on a beautiful interface based on your selected category. The generated quote(s) can be shared directly on your social media platforms.",
        link: "https://aeskay.github.io/Quotes-Generator/public/"
    },
    {
        id:14,
        name: "RAPP",
        cover: "images/portfolio/rapp.png",
        details: "RAPP is a simple 'Running Application'. It helps you document your fitness journey. You can enter your distance ran everyday, and it displays your 7 days history, along with the total distance, maximum, and average distance ran.",
        link: "https://aeskay.github.io/rapp/"
    },
    {
        id:15,
        name: "SEO Plan",
        cover: "images/portfolio/seoplan.png",
        details: "We are a creative Digital Agency based in Dublin and provide services in Branding, Web Design, Development & Maintenance, SEO, Social Media & Paid Marketing, all under one roof. ",
        link: "https://seoplan.gr8.com/"
    },
    {
        id:16,
        name: "Sparkles",
        cover: "images/portfolio/sparkles.png",
        details: "Have you ever wanted to add a little sparkle to your wardrobe, but just weren’t sure how? I’ll tell you how….its the shoes. We help you 'Feel Better with Every Step you Take'!",
        link: "https://sparkleanddesign.com/"
    },
    {
        id:17,
        name: "SPEC Church",
        cover: "images/portfolio/spec.png",
        details: "SPEC’s goals are to acquire resources for community outreach, enhancement, and to provide assistance to meet the needs of the people through prayer and service.",
        link: "https://www.specindy.org/"
    },
    {
        id:18,
        name: "Tequila Best",
        cover: "images/portfolio/tequila.png",
        details: "Tequilabest is the leading online vendor for the best, exquisite, and rare Tequilas for Purchase. We are based in San Diego, United States, but we ship globally right to your location.",
        link: "https://tequilabest.com/"
    },
    {
        id:19,
        name: "WeatherFly",
        cover: "images/portfolio/weather.png",
        details: "WeatherFly is a weather application that displays any weather information across the world. Input the name of a country, state, city, or town and watch it give you several information about the place.",
        link: "https://weatherfly-234.web.app/"
    },
    {
        id:20,
        name: "Caxus Technologies",
        cover: "images/portfolio/cacux.png",
        details: "Leaders in the AI & Data space work with us to hire engineers so they can build products, solutions to create the change that matters. We are helping companies hire data scientists and engineers to unlock new possibilities.",
        link: "https://www.caxustech.com/"
    }

]

export const reviews = [
    {
        id:1,
        image: "images/reviews/1.png"
    },
    {
        id:2,
        image: "images/reviews/2.png"
    },
    {
        id:3,
        image: "images/reviews/3.png"
    },
    // {
    //     id:4,
    //     image: "images/reviews/4.png"
    // },
    
    {
        id:6,
        image: "images/reviews/6.png"
    },
    {
        id:7,
        image: "images/reviews/7.png"
    },
    {
        id:8,
        image: "images/reviews/8.png"
    },
    {
        id:9,
        image: "images/reviews/9.png"
    },
    {
        id:10,
        image: "images/reviews/10.png"
    },
    {
        id:11,
        image: "images/reviews/11.png"
    },
    {
        id:12,
        image: "images/reviews/12.png"
    }
]